import { NgModule } from '@angular/core';
import {CommonModule, CurrencyPipe} from '@angular/common';
import {AppCommonModule} from '../common/common.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {MaterialModule} from '../material/material.module';
import {ErrorStateMatcher, ShowOnDirtyErrorStateMatcher} from '@angular/material/core';
import { AdminThemeComponent } from '../common/admin-theme/admin-theme.component';
import {DirectivesModule} from '../directives/directives.module';
import {LoginModule} from './login/login.module';
import {NgxSpinnerModule} from 'ngx-spinner';


@NgModule({
  declarations: [
    AdminThemeComponent,
  ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        AppCommonModule,
        MaterialModule,
        ReactiveFormsModule,
        DirectivesModule,
        LoginModule,
        NgxSpinnerModule
    ],
  providers: [
    {provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher},
    CurrencyPipe
  ],
  exports: [
    AdminThemeComponent
  ]
})
export class ComponentsModule { }
